enum TargetCustomerType {
    Retail = "RETAIL",
    Commercial = "COMMERCIAL"
}
export default TargetCustomerType